<button
  i18n="@@GENERAL_CLEAR"
  class="filter-actions__button filter-actions__button--clear"
  sim-button
  [disabled]="clearDisabled()"
  (click)="onClear()"
>
  Clear
</button>
<button
  class="filter-actions__button"
  sim-flat-button
  simColor="primary"
  [disabled]="applyDisabled()"
  (click)="onApply()"
>
  <span i18n="@@GENERAL_APPLY">Apply</span>
  @if (count()) {
    <span>&nbsp;({{ count() }})</span>
  }
</button>
